// #309: single source of truth for Magnaflor's public phone number, in every
// format it appears. Import from here everywhere - NEVER hardcode the number
// again. It drifted once: a fake "+1 (305) 555-0100" placeholder lived in
// lib/email/brand.ts. Real number confirmed by Alexis 2026-07-15.
//
// Formats (per #309):
//   DISPLAY  - human-visible copy in the UI + emails
//   E164     - bare E.164 (tel value, programmatic)
//   TEL_HREF - ready-made tel: link href
//   SCHEMA   - JSON-LD / schema.org telephone

export const MAGNAFLOR_PHONE_DISPLAY = "+1 (786) 753-0316";
export const MAGNAFLOR_PHONE_E164 = "+17867530316";
export const MAGNAFLOR_PHONE_TEL_HREF = "tel:+17867530316";
export const MAGNAFLOR_PHONE_SCHEMA = "+1-786-753-0316";
